// libraries
import clsx from 'clsx'

// svg
import { File } from '/react4xp/components/Icons/Ux'

// types
export interface PdfGeneratorProps {
    className?: string
    label?: string
}

// css
import './index.scss'

export default function PdfGenerator({
    className,
    label
}: PdfGeneratorProps) {
    return (
        <div className={clsx('pdf-generator', className)}>
            <button
                type='button'
                onClick={() => window.print()}
                className='button-hollow-black'
            >
                {label}
                <File />
            </button>
        </div>
    )
}